module.exports = __webpack_public_path__ + "static/img/h3.3f35b6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/h3.png
// module id = Qkdh
// module chunks = 1